baseApp.service('IntervalService', ['$timeout', '$rootScope', ($timeout, $rootScope) => {
    let intervalFactory = {};

    /**
     * This object is used a to map a key to a freq
     * The freq param is to be used as the time in milliseconds in the dynamic interval
     */
    intervalFactory.frequencies = {
        intervalServiceGetInterval: {
            freq: 20000,
        },
        mainCtrlServerMessages: {
            freq: 20000,
        },
        mainCtrlRevliteStatus: {
            freq: 3000,
        },
        routingTableFirstFetch: {
            freq: 2000,
        },
        routingTableFetch: {
            freq: 30000,
        },
        networkTopoGetTopo: {
            freq: 6000,
        },
        networkTopoGetAccountStats: {
            freq: 300000, // 5 minutes,
        },
        socketInformationGetSiteStatus: {
            freq: 5000,
        },
        singleSignOnGetAzureTenant: {
            freq: 3000,
        },
        monitorOffCloudGetRt: {
            freq: 5000,
        },
        monitorRealTimeGetRt: {
            freq: 50,
        },
        discoveryProgressBarGetProgress: {
            freq: 50,
        },
        directoryServiceProgress: {
            freq: 2000,
        },
        externalDomainProgress: {
            freq: 2000,
        },
        discoveryProgressBarProgress: {
            freq: 500,
        },
        ngTableQueryData: {
            freq: 3000,
        },
        progressBarProgress: {
            freq: 500,
        },
        typeaHeadSearch: {
            freq: 200,
        },
    }

    /**
     * This object is used a to map a key to a dynamic interval (which is actually a $timeout)
     *
     * This is mainly used cancel a dynamic interval
     */
    intervalFactory.idToInterval = new Map();


    /**
     * This object is used a to hold all the dynamic intervals that were cancelled, as a locking mechanism
     */
    intervalFactory.cancelledIntervals = new Set();


    /**
     * This function gets the frequencies from system properties and updates them
     */
     const updateIntervalIfNeeded = () => {
        store.fetch({
            path: '/getIntervalFreq',
            method : 'GET',
            success: (data) => {
                if (data) {
                    let intervalFreqMap = new Map(Object.entries(JSON.parse(data)));

                    for (let [key, value] of Object.entries(intervalFactory.frequencies)) {
                        value.freq = intervalFreqMap.get(key);
                    }
                }
            }
        });
    }

    /**
     * This function gets the call back and wraps it in the dynamic interval function
     *
     * The interval will only start, if no existing interval with the same key exists
     */
    intervalFactory.dynamicInterval = (callback, scopeId, intervalKey, invokeApply=true) => {
        let key = getIntervalMapKey(scopeId, intervalKey)
        if (!intervalFactory.idToInterval.has(key)){
            intervalFunction(callback, scopeId, intervalKey, invokeApply);
        }
    };

    /**
     * This function executes the call back
     * Then it updates the time in milliseconds to call the callback again
     * Then calls itself with the same params wrapped with $timeout() with the updated time
     * And puts the dynamic interval and a corresponding ID in the idToInterval map
     */
    const intervalFunction = (callback, scopeId, intervalKey, invokeApply) => {
        let freq = getFreq(intervalKey);
        let key = getIntervalMapKey(scopeId, intervalKey)
        if (!intervalFactory.cancelledIntervals.has(key)){
            let interval = $timeout(() => {
                doCallback(callback);
                intervalFunction(callback, scopeId, intervalKey, invokeApply)
            }, freq, invokeApply);
            intervalFactory.idToInterval.set(key, interval);
        }
    }

    /**
     * This function creates a key for the interval with is a combination of the scopeId and intervalKey
     */
    const getIntervalMapKey = (scopeId, intervalKey) => {
        return scopeId + '_' + intervalKey;
    }

    /**
     * This function runs the callback
     */
    const doCallback = (callback) => {
        if(callback) callback();
    }

    /**
     * This function retrives the time frequency from the frequencies object using the intervalKey
     */
    const getFreq = (intervalKey) => {
        return intervalFactory.frequencies[intervalKey].freq;
    }

    /**
     * This function retrives the interval from the idToInterval map and cancels it
     */
    intervalFactory.cancelDynamicInterval = (scopeId, intervalKey) => {
        let freq = getFreq(intervalKey);
        let key = getIntervalMapKey(scopeId, intervalKey);
        cancelInterval(key);
        updateCancelledIntervalSet(key, freq);
    };

    const cancelInterval = (key) => {
        let interval = intervalFactory.idToInterval.get(key);
        if (interval){
            $timeout.cancel(interval);
        }
        intervalFactory.idToInterval.delete(key);
    }

    /**
     * A dynamicInterval with the original key can start, after the key was cancelled
     *
     * We use the cancelledIntervals as a lock, to ensure the dynamicInterval does not start
     * After double the amout of time of the dynamicInterval's freq we clear the lock
     */
    const updateCancelledIntervalSet = (key, freq) => {
        intervalFactory.cancelledIntervals.add(key);

        // Remove the key from the set, after double the time freq of the original dynamicInterval
        $timeout(() => intervalFactory.cancelledIntervals.delete(key), freq * 2, false);
    }

    /**
     * This function runs updateIntervalIfNeeded() function with a dynamic interval
     */
    intervalFactory.dynamicInterval(() => updateIntervalIfNeeded(), $rootScope.$id, 'intervalServiceGetInterval', false)


    return intervalFactory;
}]);
